"use strict";
import axios from "axios";
import store from "../store";

export default class EmailVerification {
  /**
   * @param {string} email
   * @returns {Promise<boolean>}
   */
  static async verifyEmail(email) {
          const url = process.env.NODE_ENV === "development"
            ? "/api/verifyEmail"
            : `../${store.getters.getConfig["verify_email_url"]}`;
          const { data } = await axios.get(url, {
            params: { email },
            headers: {
              access_key: store.getters.getAccessKey,
            },
          });
          return Boolean(data.status);
    }
}
